import { render, staticRenderFns } from "./IdPhotoUploader.vue?vue&type=template&id=17762417&"
import script from "./IdPhotoUploader.vue?vue&type=script&lang=js&"
export * from "./IdPhotoUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports